export function toPixel( number ) {
	return number + 'px';
}